export const EMAIL_KIND_LABELS = {
    announcement: 'מודעה',
    notification: 'התראה',
    report: 'דוח',
    test: 'בדיקה',
}

export const EMAIL_OUTCOME_LABELS = {
    pending: 'ממתין',
    sent: 'נשלח',
    bounced: 'הוחזר',
    complained: 'תלונה',
    failed: 'נכשל',
}

export const NO_FIRM_LABEL = 'ללא משרד'

export const DASH = '—'

export function labelOf(labels, value) {
    return labels[value] ?? value ?? DASH
}
